import { render, staticRenderFns } from "./History.vue?vue&type=template&id=0f73c90c&scoped=true&"
var script = {}
import style0 from "./History.vue?vue&type=style&index=0&id=0f73c90c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f73c90c",
  null
  
)

export default component.exports